import { createAnimations } from '@tamagui/animations-css'

export const animations = createAnimations({
  // Smooth transitions
  quick: 'ease-out 150ms',
  medium: 'ease-out 300ms',
  lazy: 'ease-in-out 500ms',

  // Bouncy animations
  bouncy: 'cubic-bezier(0.68, -0.6, 0.32, 1.6) 400ms',

  // Fade animations
  fade: 'ease-in-out 300ms',
  fadeIn: 'ease-out 400ms',
  fadeOut: 'ease-in 300ms',

  // Scale animations
  scale: 'cubic-bezier(0.34, 1.56, 0.64, 1) 300ms',

  // Slide animations
  slideUp: 'cubic-bezier(0.16, 1, 0.3, 1) 400ms',
  slideDown: 'cubic-bezier(0.16, 1, 0.3, 1) 400ms',

  // Tooltip/popover
  tooltip: 'cubic-bezier(0.16, 1, 0.3, 1) 200ms',

  // Accordion expand/collapse
  accordion: 'cubic-bezier(0.4, 0, 0.2, 1) 300ms',
})
